import loadable from '@loadable/component';

const GhostWriterPage = loadable(() => import('./page'));
const GhostWriterForm = loadable(() => import('./[id]/form'));


export const routes = [
  {
    path: '',
    element: <GhostWriterPage />,
  },
  {
    path: ':id',
    element: <GhostWriterForm />,
  },
  
];
